module.exports = __webpack_public_path__ + "static/media/women-presenting@2x.a6c37dbc.png";